import { render } from "./CombatLogEncounters.vue?vue&type=template&id=3508b43a"
import script from "./CombatLogEncounters.vue?vue&type=script&lang=js"
export * from "./CombatLogEncounters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__